import { Injectable } from '@angular/core';

/**
 * Config Service used to setup app configuration as well as API services and proxy URLs
 * The appsettings can be overwritten during local developement by creating an appsettings.local.json file
 * and overriding properties.
 * @example
 * ```json
 *  {
      "applicationSettings":
      {
        "baseUrl": "https://dev6-api.auto-graphics.com",
        "uiapi": "https://dev6-api.auto-graphics.com/uiapi",
        "agapi": "https://dev6-api.auto-graphics.com/agapi",
        "searchapi": "https://dev6-api.auto-graphics.com/searchapi"
      }
    }
 * ```
 */
@Injectable()
export class ConfigService {
  baseUrl = '';
  agApi = '';
  expressApi = '';
  searchApi = '';
  searchApiWebSocketUrl = '';
  agApiWebSocketUrl = '';

  versionNumber = '';
  serverNumber = '';
  unreadMessageFetchIntervalInMinutes = 5;

  constructor() {
    const applicationSettings = window['appSettings']?.applicationSettings;

    this.baseUrl = applicationSettings.baseUrl;
    this.agApi = `${applicationSettings.agapi}/api/${applicationSettings.version}`;
    this.expressApi = applicationSettings.uiapi;
    this.searchApi = `${applicationSettings.searchapi}/searchapi/${applicationSettings.version}`;
    this.searchApiWebSocketUrl = `${applicationSettings.searchapi}/ws`;
    this.agApiWebSocketUrl = `${applicationSettings.agapi}/ws`;

    this.unreadMessageFetchIntervalInMinutes =
      applicationSettings.unreadMessageFetchIntervalInMinutes;

    this.versionNumber = applicationSettings.versionNumber;
    this.serverNumber = applicationSettings.serverNumber;
  }
}
